import React, { ImgHTMLAttributes } from "react"

export type RetinaImageProps = {
  name: string
  className?: string
} & ImgHTMLAttributes<HTMLImageElement>

const RetinaImage = ({ name, height, width, className }: RetinaImageProps): JSX.Element => (
  <img
    className={className}
    src={require(`../resources/images/${name}.png`)}
    srcSet={require(`../resources/images/${name}-2x.png`)}
    alt={name}
    height={height}
    width={width}
    style={{
      boxSizing: "content-box"
    }}
  />
)
export { RetinaImage }
